import { Text, rawString, type LanguageCore } from '../Language/Language';
import { Button } from '@repo/ui/Button';
import s from './FullscreenError.module.css';
import { clsx } from 'clsx';
import { Flex } from '@repo/ui/Flex';

/*
  Example strings for full experience:

  "Global.fullscreenError.primaryUrl": "/",
  "Global.fullscreenError.primaryButton": "Back to Home",

  "Global.fullscreenError.secondaryButton": "Search Peninsula",
  "Global.fullscreenError.secondaryUrl": "https://peninsulatrading.co/search",

  "Global.fullscreenError.imageUrl": "https://storage.googleapis.com/narvar-prod20-freighter-assets/narvarreturns/2cdfe912-de04-4074-9102-902fed9def3f",
 */

export const FullscreenError = ({
  title = { langKey: 'Global.fullscreenError.title' },
  description = { langKey: 'Global.fullscreenError.description' },
  secondaryButtonTitle = { langKey: 'Global.fullscreenError.secondaryButton' },
  secondaryButtonUrl = { langKey: 'Global.fullscreenError.secondaryUrl' },
  primaryButtonTitle = { langKey: 'Global.fullscreenError.primaryButton' },
  primaryButtonUrl = { langKey: 'Global.fullscreenError.primaryUrl' },
  imageUrl = { langKey: 'Global.fullscreenError.imageUrl' },
}: {
  title?: LanguageCore;
  description?: LanguageCore;
  secondaryButtonTitle?: LanguageCore;
  secondaryButtonUrl?: LanguageCore;
  primaryButtonTitle?: LanguageCore;
  primaryButtonUrl?: LanguageCore;
  imageUrl?: LanguageCore;
} = {}) => {
  const imgSrc = rawString(imageUrl);
  const secondaryUrl = rawString(secondaryButtonUrl);
  const primaryUrl = rawString(primaryButtonUrl);
  return (
    <Flex
      className={clsx([s.container, imgSrc && s.withImage])}
      direction="row"
      alignItems="center"
      justifyContent="center"
      gap="g-24"
      grow="1"
    >
      {imgSrc && (
        <Flex className={s.right} justifyContent="center" alignItems="center">
          <img className={s.image} src={imgSrc} alt="Not found" />
        </Flex>
      )}
      <Flex
        className={s.left}
        direction="column"
        justifyContent="center"
        gap="g-16"
      >
        <h2 className={s.title}>
          <Text {...title} />
        </h2>
        <p className={s.description}>
          <Text {...description} />
        </p>
        <Flex
          className={s.buttons}
          direction="row"
          gap="g-16"
          alignItems="center"
        >
          {secondaryUrl && (
            <Button variant="secondary" asChild>
              <a href={secondaryUrl} target="_blank" rel="noopener noreferrer">
                <Text {...secondaryButtonTitle} />
              </a>
            </Button>
          )}
          {primaryUrl && (
            <Button variant="primary" asChild>
              <a href={primaryUrl} target="_blank" rel="noopener noreferrer">
                <Text {...primaryButtonTitle} />
              </a>
            </Button>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
